import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from "@angular/core";
import { DialogIdentifier } from "@bca-shared/models/_enums";
import { IAddon } from "@bca-shared/models/addon";
import { IProduct } from "@bca-shared/models/product";
import { IAction } from "@bca-store/models/action";
import { createAction } from "@bca-store/models/action-creator";
import { IRootState } from "@bca-store/store.reducers";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import * as composeActions from "@bca-compose/store/compose.actions";
import * as appActions from "@bca-store/app.actions";

@Component({
  selector: "bca-choose-services-dialog",
  templateUrl: "choose-services-dialog.component.html",
  styleUrls: ["choose-services-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseServicesDialogComponent implements OnInit {
  isServicesDialogActive$: Observable<boolean>;
  selectedProduct$: Observable<IProduct>;

  constructor(private store: Store<IRootState>) {
    this.initializeObservables();
  }

  ngOnInit(): void {
    this.initializeServicesDialogStatus();
  }

  private initializeObservables(): void {
    this.selectedProduct$ = this.store.pipe(
      select(({ compose }) => compose.selectedProduct),
      filter((selectedProduct) => selectedProduct != null),
    );
  }

  private initializeServicesDialogStatus(): void {
    this.isServicesDialogActive$ = this.store.pipe(
      select(({ app }) => app.dialogStatus),
      map(
        (dialogStatus) =>
          dialogStatus[DialogIdentifier.ChooseServices] || false,
      ),
    );
  }

  closeDialog(): void {
    this.store.dispatch(
      this.createAction(
        new appActions.SetDialogStatus({
          visible: false,
          identifier: DialogIdentifier.ChooseServices,
        }),
      ),
    );
  }

  onServiceSelected(service: IAddon, selected: boolean): void {
    this.store.dispatch(
      this.createAction(
        new composeActions.SelectService({ service, selected }),
      ),
    );
  }

  trackByIdentifier(i: number, service: IAddon): string {
    return service.identifier;
  }

  private createAction(action: IAction): IAction {
    return createAction(action, ChooseServicesDialogComponent);
  }
}
